import React, { Component } from "react";
import ReactECharts from "echarts-for-react";
import close from "../../minimise_button.png";

export default class GPieChart extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: {
        // color: [
        //   "#f94144",
        //   "#577590",
        //   "#F8961E",
        //   "#F9844A",
        //   "#F9C74F",
        //   "#90BE6D",
        //   "#43AA8B",
        //   "#4D908E",
        //   "#F3722C",
        //   "#277DA1",
        // ],
        color:[
          "#9e0142",
          "#d53e4f",
          "#f46d43",
          "#fdae61",
          "#fee08b",
          "#e6f598",
          "#abdda4",
          "#66c2a5",
          "#3288bd",
          "#5e4fa2"

        ],
        // color: [
        //   "rgba(249, 65, 68, 0.9)",  /* #f94144 with 50% opacity */
        //   "rgba(87, 117, 144, 0.9)", /* #577590 with 50% opacity */
        //   "rgba(249, 150, 150, 0.9)", /* #F8961E with 50% opacity */
        //   "rgba(120, 102, 0, 0.9)", /* #F9844A with 50% opacity */
        //   "rgba(249, 199, 79, 0.9)", /* #F9C74F with 50% opacity */
        //   "rgba(144, 190, 109, 0.9)",/* #90BE6D with 50% opacity */
        //   "rgba(67, 170, 139, 0.9)", /* #43AA8B with 50% opacity */
        //   "rgba(177, 144, 142, 0.9)", /* #4D908E with 50% opacity */
        //   "rgba(240, 94, 16,0.9)", /*rgb(240, 94, 16) with 50% opacity */
        //   "rgba(39, 125, 161, 0.9)"  /* #277DA1 with 50% opacity */
        // ],


        title: {
          text: props.title,
          left: "center",
          textStyle: {
            fontSize: 16,
            fontWeight: "bold",
            color: "#0000ff",
          },
        },
        tooltip: {
          trigger: "item",
          formatter: "{b} - {c} ({d}%)",
        },
        toolbox: {
          feature: {
            myMinimize: {
              show: true,
              title: "Minimize",
              icon: `image://${close}`,
           

              onclick: props.toggleVisibleGraphPanel,
            },
              iconStyle: {
                normal: {
                  width: 40,  // Increase the width of the icon
                  height: 40, // Increase the height of the icon
                },
                emphasis: {
                  width: 40,  // Make sure the size stays the same when hovered/focused
                  height: 40, // You can also change this if you want a different size on hover
                }
              },
             
           
          },
        },
       
        legend: {
            orient: 'vertical',
            left: 'right',
            top: '13%',
          },
        series: [
          {
            name: props.title,
            type: "pie",
            radius: "80%",
            center: ["30%", "50%"],
            data: props.series.map((value, index) => ({
              value,
              name: props.categories[index],
            })),
            label: {
                show: false,
                position: 'center'
              },
            // label: {
            //   show: true,
            //   formatter: (params) => {
            //     const { name, value, percent } = params;
            //     return `${percent}%`;
            //   },
            //   fontSize: 11,
            //   position: "inside",
            //   fontColor:"rgba(0, 0, 0, 0.5)",
            // },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: "rgba(0, 0, 0, 0.5)",
              },
            },
          },
        ],
      },
    };
  }

  componentDidUpdate(prevProps) {
    // Update chart options if props change
    if (
      prevProps.title !== this.props.title ||
      prevProps.series !== this.props.series ||
      prevProps.categories !== this.props.categories
    ) {
      this.setState({
        options: {
          ...this.state.options,
          title: {
            ...this.state.options.title,
            text: this.props.title,
          },
          series: [
            {
              ...this.state.options.series[0],
              name: this.props.title,
              data: this.props.series.map((value, index) => ({
                value,
                name: this.props.categories[index],
              })),
            },
          ],
        },
      });
    }
  }

  render() {
    return (
      <ReactECharts    
        option={this.state.options}
        style={{ width: "100%", height: "100%" }}
        className={this.props.classname}
      />
    );
  }
}
